import type { Exercise, MuscleGroup } from '../types';
import { normalizeExerciseName } from '../../shared/utils/number';

const entries: Array<[string, MuscleGroup]> = [
  ['Жим штанги лёжа', 'Грудь'], ['Жим гантелей лёжа', 'Грудь'],
  ['Жим гантелей на наклонной скамье', 'Грудь'], ['Разведение гантелей лёжа', 'Грудь'],
  ['Отжимания', 'Грудь'], ['Сведение рук в кроссовере', 'Грудь'],
  ['Становая тяга', 'Спина'], ['Подтягивания', 'Спина'], ['Тяга верхнего блока', 'Спина'],
  ['Тяга штанги в наклоне', 'Спина'], ['Тяга гантели одной рукой', 'Спина'],
  ['Горизонтальная тяга блока', 'Спина'], ['Гиперэкстензия', 'Спина'],
  ['Приседания со штангой', 'Ноги'], ['Жим ногами', 'Ноги'], ['Румынская тяга', 'Ноги'],
  ['Выпады с гантелями', 'Ноги'], ['Болгарские выпады', 'Ноги'], ['Разгибание ног', 'Ноги'],
  ['Сгибание ног', 'Ноги'], ['Подъёмы на носки', 'Ноги'],
  ['Жим штанги стоя', 'Плечи'], ['Жим гантелей сидя', 'Плечи'],
  ['Махи гантелями в стороны', 'Плечи'], ['Разведение гантелей в наклоне', 'Плечи'],
  ['Обратная бабочка', 'Плечи'], ['Подъём штанги на бицепс', 'Руки'],
  ['Сгибание рук с гантелями', 'Руки'], ['Молотковые сгибания', 'Руки'],
  ['Французский жим', 'Руки'], ['Разгибание рук на верхнем блоке', 'Руки'],
  ['Отжимания на брусьях', 'Руки'], ['Планка', 'Кор'], ['Скручивания', 'Кор'],
  ['Подъём ног в висе', 'Кор']
];

export const SEED_VERSION = 1;

export function baseExerciseCatalog(timestamp: string): Exercise[] {
  return entries.map(([name, muscleGroup], index) => ({
    id: `10000000-0000-0000-0000-${String(index + 1).padStart(12, '0')}`,
    name,
    normalizedName: normalizeExerciseName(name),
    muscleGroup,
    isCustom: false,
    isArchived: false,
    createdAt: timestamp,
    updatedAt: timestamp
  }));
}
